var isPlainObject = function (val) {
    return typeof val === 'object' && val !== null && !Array.isArray(val);
};
/**
 * Validate that the parsed payload matches the minimal `FormConfig`
 * shape (tabs[] of { id, fields[] of { tag, subfields[] } }). Anything
 * deeper (label, indicators, components, ...) is treated as opaque so
 * round-trip preserves unknowns.
 */
var validateShape = function (raw) {
    if (!isPlainObject(raw)) {
        return { ok: false, path: '', message: 'Kořenový dokument musí být objekt.', isSyntax: false };
    }
    if (!Array.isArray(raw.tabs)) {
        return { ok: false, path: 'tabs', message: 'Vlastnost `tabs` musí být pole.', isSyntax: false };
    }
    for (var t = 0; t < raw.tabs.length; t += 1) {
        var tab = raw.tabs[t];
        if (!isPlainObject(tab)) {
            return { ok: false, path: "tabs.".concat(t), message: 'Záložka musí být objekt.', isSyntax: false };
        }
        if (typeof tab.id !== 'string') {
            return { ok: false, path: "tabs.".concat(t, ".id"), message: 'Záložka musí mít `id` jako string.', isSyntax: false };
        }
        if (!Array.isArray(tab.fields)) {
            return { ok: false, path: "tabs.".concat(t, ".fields"), message: 'Záložka musí mít `fields` jako pole.', isSyntax: false };
        }
        for (var f = 0; f < tab.fields.length; f += 1) {
            var field = tab.fields[f];
            if (!isPlainObject(field)) {
                return { ok: false, path: "tabs.".concat(t, ".fields.").concat(f), message: 'Pole musí být objekt.', isSyntax: false };
            }
            if (typeof field.tag !== 'string') {
                return {
                    ok: false,
                    path: "tabs.".concat(t, ".fields.").concat(f, ".tag"),
                    message: 'Pole musí mít `tag` jako string.',
                    isSyntax: false,
                };
            }
            // CZNA-500 — `subfields` is optional. A MARC control field has none, and
            // the packaged templates write it exactly that way
            // (`{"tag":"001","readOnly":true,"hideOnCreate":true}`); only the EFC
            // compiler fills in `subfields: []`. Demanding an array here rejected
            // every PERSONAL / CORPORATE / MEETING template on the raw→visual
            // toggle, with a message that read like the admin had broken the JSON.
            // A PRESENT-but-not-an-array value is still a genuine error.
            if (field.subfields !== undefined && !Array.isArray(field.subfields)) {
                return {
                    ok: false,
                    path: "tabs.".concat(t, ".fields.").concat(f, ".subfields"),
                    message: 'Pole musí mít `subfields` jako pole.',
                    isSyntax: false,
                };
            }
        }
    }
    return { ok: true };
};
export var parseRawToConfig = function (rawText) {
    var parsed;
    try {
        parsed = JSON.parse(rawText);
    }
    catch (err) {
        return {
            ok: false,
            path: '',
            message: err instanceof Error ? err.message : 'Neplatný JSON',
            isSyntax: true,
        };
    }
    var shape = validateShape(parsed);
    if (shape.ok !== true)
        return shape;
    return { ok: true, config: parsed };
};
